export enum CUSTOM_SECOND_SELECT {
    CanAdapters = "canAdapters",
    CanVehicles = "canVehicles",
    FeatureControl = "featureControl",
    Logs = "logs",
    SetBluetoothPassword = "setBluetoothPassword"
}
